import { ComponentComposerPluginFactory } from '@duerrdental/component-composer'
import { defineNuxtPlugin } from 'nuxt/app'
import i18nSettings from '~/plugins/i18n/settings'
import type { Plugin } from '~/plugins/plugins'

const PLUGIN_INSTALLED = Symbol('componentComposerInstalled')

export const cocoPlugin: Plugin = (nuxtApp) => {
  // Prevent multiple installations to avoid memory leaks
  if (nuxtApp.vueApp.config.globalProperties[PLUGIN_INSTALLED]) {
    return
  }

  const components = {
    text: { component: 'atoms-form-text-input' }
  }
  const factory = new ComponentComposerPluginFactory()
  const locales = i18nSettings.locales.map(({ code }) => code)
  const plugin = factory.create(components, locales)

  nuxtApp.vueApp.use(plugin)

  // Mark as installed
  nuxtApp.vueApp.config.globalProperties[PLUGIN_INSTALLED] = true
}

export default defineNuxtPlugin(cocoPlugin)
